import React, { useState, useEffect } from 'react';
import './Dashboard.scss';
import LocationMap from './DataguardLocationMap';
import { useSelector } from "react-redux";
import DataguardHeatmap from './DataguardHeatmap';
import DataguardRoles from './DataguardRoles';
import DataguardBehaviorModel from './DataguardBehaviorModel';
import { useDispatch } from 'react-redux';
import DataguardIncognito from './DataguardIncognito';
import Popup from "reactjs-popup";
import LocationCard from './components/LocationCard';
import BehaviorModelsCard from './components/BehaviorModelsCard';
import PublicDataCard from './components/PublicDataCard';
import RolesCard from './components/RolesCard';
import { useHistory } from "react-router-dom";
import { DashboardMainHeader } from '../DataGuardCommonComponents';

const Dashboard = () => {
  const dispatch = useDispatch();
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedGraph, setSelectedGraph] = useState(null);
  let history = useHistory();

  const showExpandedView = (graph) => {
    setSelectedGraph(graph);
    setIsExpanded(true);
  }

  
  // Navigation helper functions for dashboard cards
  const navigateToDetails = (pageType) => {
    history.push(`/tenant/details/${pageType}`);
  };

  // Individual navigation functions for each card type
  const navigateToLocations = () => navigateToDetails('locations');
  const navigateToRoles = () => navigateToDetails('roles');
  const navigateToPublicData = () => navigateToDetails('publicdata');
  const navigateToBehaviorModels = () => navigateToDetails('behaviormodels');
  

  const renderPopupGraph = () => {
    if (selectedGraph === "locations") {
      return (
        <div className="dataguard-dashboard-container">
          <div className="dataguard-dashboard-content">
            <div className="dashboard-row bottom-row">
              <LocationCard isPopup={true} showExpandedView={() => null} />
            </div>
          </div>
        </div>
      );
    } else if (selectedGraph === "roles") {
      return (
        <div className="dataguard-dashboard-container">
          <div className="dataguard-dashboard-content">
            <div className="dashboard-row bottom-row">
              <RolesCard showExpandedView={() => null} isPopup={true} />
            </div>
          </div>
        </div>
      );
    } else if (selectedGraph === "heatmap") {
      return (
        <div className="dataguard-dashboard-container">
          <div className="dataguard-dashboard-content">
            <div className="dashboard-row bottom-row">
              <PublicDataCard isPopup={true} showExpandedView={() => null} />
            </div>
          </div>
        </div>
      );
    } else if (selectedGraph === "policy") {
      return (
        <div className="dataguard-dashboard-container">
          <div className="dataguard-dashboard-content">
            <div className="dashboard-row bottom-row">
              <BehaviorModelsCard isPopup={true} showExpandedView={() => null} />
            </div>
          </div>
        </div>
      );
    }
    return null;
  }

  return (
    <div className="dataguard-dashboard-container">
      <div className='dataguard-dashboard-content'>
        <div className={isExpanded ? "sys-guard-backdrop" : ""}>
          <Popup
            open={isExpanded}
            onClose={() => setIsExpanded(false)}
            modal
            contentStyle={{
              transition:
                "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
              transform: isExpanded ? "scale(1)" : "scale(0.9)",
              opacity: isExpanded ? "1" : "0",
              width: "auto"
            }}
          >
            <div className={`sys-guard-dashboard-popup-container data-guard-dashboard-popup-container ${selectedGraph}`}>
              {renderPopupGraph()}
              <button className="sys-guard-popup-close-button" onClick={() => setIsExpanded(false)}>
                &times;
              </button>
            </div>
          </Popup>
        </div>
        <DashboardMainHeader title="DataGuard Dashboard" loc="dashboard"/>
        <div className='dashboard-body'>
          <div className="dashboard-row bottom-row">
            <LocationCard showExpandedView={showExpandedView} onClick={navigateToLocations}/>
            <BehaviorModelsCard showExpandedView={showExpandedView} onClick={navigateToBehaviorModels}/>
          </div>

          <div className="dashboard-row bottom-row">
            <PublicDataCard showExpandedView={showExpandedView} onClick={navigateToPublicData}/>
            <RolesCard showExpandedView={showExpandedView} onClick={navigateToRoles}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
